import api from "../Component/axios";

export const useNotificationNumbers = () => {
  const token = localStorage.getItem("@Token");
  const getNotificationNumbers = async (tipo) => {
    try {
      const response = await api.get(
        `api/permisos/notification-numbers/?type=${tipo}&id_campo=${localStorage.getItem(
          "codigo_campo"
        )}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const getPedidoEmpaqueNotificationNumbers = async () => {
    try {
      const response = await api.get(
        `api/permisos/notification-numbers/?type=$empaque`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  return { getNotificationNumbers, getPedidoEmpaqueNotificationNumbers };
};
